export default "__VITE_ASSET__CDIStrKn__"